export class AkMessage {
    lobId: number;
    topicKey: string;
    message: string;
    policyNumber?: string;
    claimNumber?: string;
    errors?: object;
    dms2docId?: string;
    dms2docBrandId?: number;
    dms2docCatId?:number;
    dms2DocboxId?: number;
    mailSubj?: string;
    messageId?: number;
    dms2Actnumber: string | null;
    dms2Secflag: string | null;
}
